
// import { PropType } from 'vue'
// import Vue, { PropType } from 'vue'
// import { mapGetters } from 'vuex'
import toggleArrayItemMixin from '@/mixins/toggleArrayItemMixin'

import cloneDeep from 'lodash.clonedeep'

import JDateField from '@/ui/controls/JDateField.vue'
import PlantAvatar from '@/ui/components/plants/PlantAvatar.vue'
import JFileInputImage from '@/ui/controls/JFileInputImage.vue'

import { formatDate } from '@/helpers/dateHelpers'
import Plant from '@/models/Plant'
import Harvest from '@/models/Harvest'
// import Harvest from '@/models/Harvest';
import { id } from '@/types/models'
import JFileContainer from '@/models/JFileContainer'

// import { uploadFileToFirestore } from '@/firebase/storage'

import { HarvestInput } from '@/types/store'

const DEFAULT_HARVEST_ITEM: HarvestInput = {
  date: formatDate(new Date()),
  quantity: 1,
  quality: undefined,
  ripeness: undefined,
  size: undefined,
  traits: [],
  note: null,
}

interface DialogObject {
  show: boolean
  value?: string
}

interface HarvestNumberInput {
  quantity: number
}

// const getKeyValue = <T extends object, U extends keyof T>(key: U) => (obj: T) => obj[key];

export default toggleArrayItemMixin.extend({
  components: {
    JDateField,
    PlantAvatar,
    JFileInputImage,
  },
  // mixins: [toggleArrayItemMixin],
  props: {
    // value: [String as PropType<id>, Array as PropType<id[]>],
    // value: Array as PropType<id[]>,
    gardenId: String,
    plantId: String,
    // fullscreen: Boolean,
  },
  data: () => ({
    input: cloneDeep(DEFAULT_HARVEST_ITEM) as HarvestInput,
    images: [] as Array<JFileContainer>,

    submitting: false,
    additionalTraits: [] as string[],

    additionalTraitDialog: {
      show: false,
      value: undefined,
    } as DialogObject,

    showAllTraits: false,
  }),
  computed: {
    // ...mapGetters([
    //   'plants'
    // ]),
    plants(): Array<Plant> {
      return this.$store.getters['gardens/plants/inGarden'](this.gardenId)
    },
    fullscreen(): boolean {
      return this.$vuetify.breakpoint.xsOnly
    },
    plant(): Plant {
      return this.$store.getters['gardens/plants/find'](this.plantId)
    },
    // plantId(): id {
    //   return Array.isArray(this.value) ? this.value[0] : this.value
    // },
    allTraitItems(): string[] {
      return [...new Set([...this.traitItems, ...this.additionalTraits])]
    },
    traitItems(): string[] {
      return this.plants
        .map((p: Plant) => p.harvests.map((h: Harvest) => h.traits || []))
        .flat(2)
      // console.log(items.flat(2))
      // // console.log([...new Set(...this.plants.map(p => (p.harvests || []).map(h => (h.traits || []))))])
      // return [...new Set(...this.plants.map(p => (p.harvests || []).map(h => (h.traits || []))))]
    },
    // plant() {
    //   return this.$store.getters.plant(this.plantId)
    // },
  },
  methods: {
    // inc(propName: string): void {
    inc(key: keyof HarvestInput) {
      this.input[key]++
    },
    dec(key: keyof HarvestInput): void {
      if (Number(this.input[key]) > 1) this.input[key]--
    },
    onPlantChange(e: id): void {
      this.$emit('input', [e])
    },
    onFileChange(v: Array<JFileContainer>) {
      this.images = v
    },
    onInputQuantityBlur(e: Event): void {
      const target = e.target as HTMLInputElement
      this.input.quantity = Number(target.value)
    },
    addAdditionalTrait(newTrait?: string, autoselect = true): void {
      if (!newTrait || newTrait.trim().length < 1) {
        this.$store.dispatch('snackbars/error', 'Invalid trait')
        return
      }
      this.additionalTraits.push(newTrait)
      this.additionalTraitDialog.value = undefined
      this.additionalTraitDialog.show = false
      if (autoselect) this.toggleArrayItem(newTrait, this.input.traits)
    },

    isInvalid() {
      const isIntegerGreaterThan = (val: number, min = 0) =>
        Number.isInteger(val) && val > min
      const isNumberBetween = (val?: number, min = 1, max = 5) =>
        typeof val === 'number' && val >= min && val <= max

      if (!this.plantId) return 'select plant'
      if (!this.input.date) return 'select a date'
      if (!isIntegerGreaterThan(this.input.quantity, 0))
        return 'invalid quantity'
      if (!isNumberBetween(this.input.quality, 0, 5)) return 'invalid quality'
      if (!isNumberBetween(this.input.ripeness)) return 'invalid ripeness'
      if (!isNumberBetween(this.input.size)) return 'invalid size'
    },
    resetInput(defaultObj = DEFAULT_HARVEST_ITEM): void {
      this.input = cloneDeep(defaultObj)
      this.images = []
    },
    submitAndClose(): void {
      this.submit(true)
      // .then(res => this.$emit('close'))
    },
    submitAndClear(): void {
      this.submit().then(() => this.resetInput())
    },
    submit(closeOnSuccess = false): Promise<object[]> {
      // validate form
      const isInvalid = this.isInvalid()
      if (isInvalid) {
        this.$store.dispatch('snackbars/error', isInvalid)
        throw Error(isInvalid)
      }

      this.submitting = true
      return new Promise((resolve, reject) => {
        // Promise.all(
        //   this.value.map(plantId => this.$store.dispatch('plants/harvests/add', { plantId, harvest: this.input }))
        // )
        //   .then(res => this.$store.dispatch('snackbars/add', `Added ${res.length} harvest(s)`))
        this.$store
          .dispatch('gardens/plants/harvests/add', {
            gardenId: this.gardenId,
            plantId: this.plantId,
            harvest: this.input,
            images: this.images || [],
          })
          .then((res) => {
            if (closeOnSuccess) this.$emit('close')
            resolve(res)
          })
          .then(() =>
            this.$store.dispatch(
              'snackbars/add',
              `Added harvest to ${this.plant.name}`
            )
          )
          .catch((err) => {
            this.$store.dispatch('snackbars/error', err.message)
            reject(err)
          })
          .finally(() => (this.submitting = false))
      })
    },
  },
})
